import { endPoint } from "constants/server/api";
import { createFetchMaster } from "../../utils/fetchFactory";
import { createSlicePrototype } from "../../utils/sliceFactory";
var getAllMstNewItemPesColSlice = createSlicePrototype({
    name: "getAllMstNewItemPesCol"
});
export var getAllMstNewItemPesCol = createFetchMaster({
    actions: getAllMstNewItemPesColSlice.actions,
    config: {
        method: "get",
        url: endPoint.MST_NEW_ITEM_PES_COL
    }
});
var _getAllMstNewItemPesColSlice_actions = getAllMstNewItemPesColSlice.actions;
export var fetchData = _getAllMstNewItemPesColSlice_actions.fetchData, fetchDataSuccess = _getAllMstNewItemPesColSlice_actions.fetchDataSuccess, fetchDataFailure = _getAllMstNewItemPesColSlice_actions.fetchDataFailure, resetState = _getAllMstNewItemPesColSlice_actions.resetState;
export default getAllMstNewItemPesColSlice.reducer;
